export default "__VITE_ASSET__ePjXvc0M__"